
import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {
    marginLeft: theme.spacing(3),
    marginBottom: theme.spacing(2.5),
    paddingLeft: theme.spacing(2),
    lineHeight: 1.8,
    '& > li': {
      marginBottom: theme.spacing(1)
    },
    '& ul, & ol': {
      marginTop: theme.spacing(1),
      marginBottom: 0
    }
  }
}));

function List({
  variant: Component,
  children,
  ...rest
}) {
  const classes = useStyles();

  return (
    <Component
      className={classes.root}
      {...rest}
    >
      {children}
    </Component>
  );
}

List.propTypes = {
  children: PropTypes.any,
  variant: PropTypes.oneOf(['ul', 'ol'])
};

export default List;
